"use client";

import { Shield, Globe, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CoreValues() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const values = [{
    icon: Shield,
    title: "Transparency",
    description: "Clear documentation and honest communication at every step of the supply chain."
  }, {
    icon: Globe,
    title: "Global Reach",
    description: "Extensive network spanning Middle East, Africa, Asia, and Europe for comprehensive coverage."
  }, {
    icon: Zap,
    title: "Speed & Reliability",
    description: "On-time delivery and responsive service ensuring your operations never miss a beat."
  }];
  return <section id="core-values" className="dark bg-background text-foreground relative py-24 px-4 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <svg viewBox="0 0 1200 800" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <path d="M200,300 L250,280 L300,290 L350,270 L400,285 L450,275 L500,290 L550,280 L600,295 L650,285 L700,300 L750,290 L800,305 L850,295 L900,310 L950,300 L1000,315" stroke="currentColor" strokeWidth="1" fill="none" />
          <path d="M150,400 L200,390 L250,405 L300,395 L350,410 L400,400 L450,415 L500,405 L550,420 L600,410 L650,425 L700,415 L750,430 L800,420 L850,435 L900,425 L950,440 L1000,430 L1050,445" stroke="currentColor" strokeWidth="1" fill="none" />
          <circle cx="300" cy="350" r="3" fill="currentColor" />
          <circle cx="500" cy="380" r="3" fill="currentColor" />
          <circle cx="700" cy="360" r="3" fill="currentColor" />
          <circle cx="900" cy="390" r="3" fill="currentColor" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4">
            Our Core Values
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Built on a foundation of trust, global expertise, and unwavering commitment to excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {}
          <div ref={ref1} data-index={0} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" style={{
          opacity: isVisible1 ? 1 : 0,
          transform: isVisible1 ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "0ms"
        }}>
            <Card className="bg-primary text-foreground-primary h-full border border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:shadow-strong hover:-translate-y-1.5 hover:border-accent group">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:rotate-12">
                  <Shield className="w-16 h-16 text-accent stroke-[1.5]" />
                </div>
                <h3 className="text-2xl font-display font-bold mb-4">
                  {values[0].title}
                </h3>
                <p className="text-foreground-primary/80 leading-relaxed">
                  {values[0].description}
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={ref2} data-index={1} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" style={{
          opacity: isVisible2 ? 1 : 0,
          transform: isVisible2 ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "100ms"
        }}>
            <Card className="bg-primary text-foreground-primary h-full border border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:shadow-strong hover:-translate-y-1.5 hover:border-accent group">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:rotate-12">
                  <Globe className="w-16 h-16 text-accent stroke-[1.5]" />
                </div>
                <h3 className="text-2xl font-display font-bold mb-4">
                  {values[1].title}
                </h3>
                <p className="text-foreground-primary/80 leading-relaxed">
                  {values[1].description}
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={ref3} data-index={2} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" style={{
          opacity: isVisible3 ? 1 : 0,
          transform: isVisible3 ? "translateY(0)" : "translateY(20px)",
          transitionDelay: "200ms"
        }}>
            <Card className="bg-primary text-foreground-primary h-full border border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:shadow-strong hover:-translate-y-1.5 hover:border-accent group">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="mb-6 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:rotate-12">
                  <Zap className="w-16 h-16 text-accent stroke-[1.5]" />
                </div>
                <h3 className="text-2xl font-display font-bold mb-4">
                  {values[2].title}
                </h3>
                <p className="text-foreground-primary/80 leading-relaxed">
                  {values[2].description}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}